<template>
    <app-vue-picture-swipe :items="items"></app-vue-picture-swipe>
</template>
<script>
import items from './namePhotosObjects';
import VuePictureSwipe from 'vue-picture-swipe';
export default {
    components: {
       appVuePictureSwipe: VuePictureSwipe
    },

    data() {
        return {
            items: items
        };
    }
};
</script>
<style>
.pswp__button--share {
    display: none;
}
</style>
